import { lazy, Suspense } from "react";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import HomePage from "@/pages/v2/Home";
import TopicPage from "@/pages/v2/TopicPage";
import TopicIndexPage from "@/pages/v2/TopicIndexPage";
import CategoryPage from "@/pages/v2/CategoryPage";
import ArticlePage from "@/pages/v2/ArticlePage";
import AboutPage from "@/pages/v2/AboutPage";
import EditorialPage from "@/pages/v2/EditorialPage";
import SearchPage from "@/pages/v2/SearchPage";
import TrendarPage from "@/pages/v2/TrendarPage";
import TrendarArticlePage from "@/pages/v2/TrendarArticlePage";
import Gone410 from "@/pages/v2/Gone410";
import NotFound from "@/pages/NotFound";
import OAuthConsent from "@/pages/OAuthConsent";

// Admin loads only when visited
const Admin = lazy(() => import("@/pages/Admin"));

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 60_000, refetchOnWindowFocus: false } },
});

const App = () => (
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/om" element={<AboutPage />} />
            <Route path="/om-korthet" element={<AboutPage />} />
            <Route path="/om-korthet/redaktionen" element={<EditorialPage />} />
            <Route path="/redaktionen" element={<EditorialPage />} />

            <Route path="/sok" element={<SearchPage />} />
            <Route path="/trendar" element={<TrendarPage />} />
            <Route path="/trendar/:slug" element={<TrendarArticlePage />} />

            {/* Managed OAuth consent (MCP-klienter) */}
            <Route path="/.lovable/oauth/consent" element={<OAuthConsent />} />

            {/* 410 Gone must come before generic /:category/:slug */}
            <Route path="/politik/analys" element={<Gone410 />} />
            <Route path="/politik/analys/*" element={<Gone410 />} />

            <Route
              path="/admin/*"
              element={
                <Suspense fallback={<div style={{ padding: 24 }}>Laddar admin…</div>}>
                  <Admin />
                </Suspense>
              }
            />

            <Route path="/amnen" element={<TopicIndexPage />} />
            <Route path="/amne/:topic" element={<TopicPage />} />
            <Route path="/:category" element={<CategoryPage />} />
            <Route path="/:category/:slug" element={<ArticlePage />} />

            <Route path="*" element={<NotFound />} />
          </Routes>
          <Toaster />
          <Sonner />
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </HelmetProvider>
);

export default App;
